/**
 * Stand-in for a registry page S2 has not ported yet.
 *
 * It exists so the route table can be generated from `PAGE_REGISTRY` in full
 * (see `routes.tsx`) instead of listing only the pages that happen to be done.
 * A generated table means a page can never end up routed-but-ungated.
 *
 * It deliberately says WHICH page and WHERE it still works, rather than
 * pretending to be a 404 — the Next.js app is still running and still serving
 * this page for the length of the transition.
 */
import { Construction } from "lucide-react";
import Link from "@/compat/link";
import type { PageDef } from "@/lib/rbac/pages";

export function PagePlaceholder({ page }: { page: PageDef }) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-6 text-center">
      <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-[var(--cp-accent-wash)]">
        <Construction className="h-8 w-8 text-[var(--cp-accent-ink)]" aria-hidden="true" />
      </div>
      <h1 className="mb-2 text-2xl font-bold text-[var(--cp-ink)]">{page.label}</h1>
      <p className="mb-6 max-w-md text-sm text-[var(--cp-ink-2)]">
        This page hasn&apos;t moved to the new frontend yet. Your access to it is
        unchanged — it is still live on the current app at{" "}
        <code className="rounded bg-[var(--cp-surface-2)] px-1.5 py-0.5 text-[var(--cp-ink)]">
          {page.href}
        </code>
        .
      </p>
      <Link
        href="/dashboard"
        className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
      >
        Back to Dashboard
      </Link>
    </div>
  );
}
